import React, { Fragment, useState } from 'react'
import { Grid, ListItem, Divider } from '@mui/material'
import { styled } from '@mui/system';
import { DownloadButton } from '../DownloadButton';
import { ConsentButton } from '../ConsentButton';
import { ConsentStatus } from '../ConsentStatus';

const StyledDivider = styled(Divider)`
  border: solid thin #9e4db6;
  border-top: thin;
`;

export const TermsItem = ({ name, description, documentName, consent, index, userCanSign, ...rest }) => {
  const [isDownloaded, setIsDownloaded] = useState(false);

  return (
    <Fragment>
      {index > 0 && <StyledDivider />}
      <ListItem>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            {name}
          </Grid>
          <Grid item xs={5}>
            {description}
          </Grid>
          <Grid container xs={2} alignItems="center" direction="column">
            <Grid item>
              {documentName && <DownloadButton {...rest} onFileDownloaded={() => setIsDownloaded(true)} documentName={documentName} />}
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <ConsentStatus {...consent} />
            <ConsentButton status={consent} {...rest} disabled={(!isDownloaded && !!documentName) || !userCanSign} />
          </Grid>
        </Grid>
      </ListItem>
    </Fragment>
  );
};
